const header = () => {
  const init = () => {
    selectArticle();
  };

  const selectArticle = () => {
    const articles = document.querySelectorAll(".article .article__nav");
    if (articles.length === 0) return;

    firstActive();
    for (const article of articles.entries()) {
      article[1].addEventListener("click", (e) => {
        clearBackground();
        e.currentTarget.classList.add("nav-active");
        changeTitle(e);
        changeContent(e);
      });
    }
  };

  const firstActive = () => {
    const articles = document.querySelectorAll(".article .article__nav");
    const contents = document.querySelectorAll(".article__content");
    articles[0].classList.add("nav-active");
    contents[0].classList.add("content-active");
  };

  const clearBackground = () => {
    const articles = document.querySelectorAll(".article .article__nav");
    for (let article of articles) {
      article.classList.remove("nav-active");
    }
  };

  const changeTitle = (event) => {
    const currentTitle = event.currentTarget.querySelector(
      ".article__nav-title"
    ).innerText;
    document.querySelector(".article__title .et_pb_text_inner").innerText =
      currentTitle;
  };

  const changeContent = (event) => {
    const contents = document.querySelectorAll(".article__content");
    for (const content of contents.entries()) {
      content[1].classList.remove("content-active");
    }

    const currentNumber = event.currentTarget.querySelector(
      ".article__nav-number"
    ).innerText;

    const currentActive = currentNumber.replace(" ", "-");
    document.querySelector(`.${currentActive}`).classList.add("content-active");
  };

  init();
};

try {
  header();
} catch (error) {
  console.log(error);
}
